// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/root/workspace/__flow_work/__flow_builds/4996d35e-80bf-4831-a299-77a7e851877a/workspace/jump_rope_together_admin_SfDL/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: '@@initialState', model: model_1 },
} as const
